Ext.ns('mx.comp');

mx.comp.LinkedLovComboImproved = Ext.extend(mx.comp.LinkedLovCombo, {
    remoteMode: false,
    getValue: function() {
        var r = [];
        if (this.value && this.value.length) {
            for (var i = 0; i < this.value.length; i++) {
                if (this.value[i].get) {
                    r.push(this.value[i].get(this.valueField));
                } else {
                    r.push(this.value[i]);
                }
            }
        }
        return r.length ? r : null;
    },
    getCheckedDisplay: function() {
        var displayValue = '';
        var value = this.getValue ? this.getValue() : this.value;
        if (value) {
            for (var i = 0; i < value.length; i++) {
                if (this.remoteMode) {
                    // in remote mode we are here before store is loaded...
                    displayValue += (i != 0 ? this.separator + ' ' : '') + Ext.util.Format.htmlDecode(value[i]);
                } else {
                    var r = this.store.getAt(this.store.find(this.valueField, value[i]));
                    if (r) {
                        displayValue +=
                            (i != 0 ? this.separator + ' ' : '') + Ext.util.Format.htmlDecode(r.get(this.displayField));
                    }
                }
            }
        }
        return displayValue;
    },

    expand: function() {
        if (!this.storeRefreshed) {
            var snapshot = this.store.snapshot || this.store.data;
            if (!Ext.isArray(this.value)) {
                this.value = new Array();
            }
            snapshot.each(function(r) {
                var isEditing = r.editing;
                r.editing = this.forbidEditingMode;
                r.set(
                    this.checkField,
                    this.value.indexOfUsing(function(value, i, values) {
                        if (value.get) {
                            return value.get(this.valueField) == r.get(this.valueField);
                        } else {
                            return value == r.get(this.valueField);
                        }
                    }) != -1
                );
                r.editing = isEditing;
            }, this);
            this.view.refresh();
            this.storeRefreshed = true;
        }

        mx.comp.LinkedLovCombo.superclass.expand.call(this);
    },
    initDataView: function() {
        if (this.view) {
            var parent = this;
            this.view.prepareData = function(data) {
                if (parent.value) {
                    Ext.each(
                        parent.value,
                        function(v) {
                            if ((v.get && data['id'] == v.get('id')) || data[parent.valueField] == v) {
                                data[parent.checkField] = true;
                                return false;
                            }
                        },
                        this
                    );
                }
                return data;
            };
        }
    },
    setValue: function(v) {
        if (v) {
            if (Ext.isArray(v)) {
                var thiz = this;
                this.value = v.map(function(v) {
                    return thiz.transformValue(v);
                });
            } else if (v instanceof Ext.data.Record) {
                if (!Ext.isArray(this.value)) {
                    this.value = new Array();
                }
                if (v.get(this.checkField)) {
                    //                    v.data[this.checkField] = true;
                    this.value.push(v);
                } else {
                    //                    v.data[this.checkField] = false;
                    var thiz = this;
                    var index = this.value.indexOfUsing(function(value, i, values) {
                        return value.get ? value.get('id') == v.get('id') : value == v.get(thiz.valueField);
                    });
                    if (index != -1) {
                        this.value.splice(index, 1);
                    }
                }
            }
            var displayValue = this.getCheckedDisplay();
            if (this.el) {
                this.setRawValue(displayValue);
            }
            if (this.hiddenField) {
                this.hiddenField.value = this.value;
            }
            if (this.el) {
                this.el.removeClass(this.emptyClass);
            }
            if (displayValue == '') {
                if (this.el) {
                    this.clearValue();
                }
            }
            if (this.view) {
                this.view.all.clear();
            }
        } else {
            this.clearValue();
        }
    },
});
